import React from 'react';
import { Box, useTheme, alpha } from '@mui/material';

const LoadingSpinner = ({ size = 'medium', fullScreen = false }) => {
  const theme = useTheme();
  
  // Size presets
  const sizes = {
    small: {
      container: 80,
      ring: 100,
      logo: 60,
    },
    medium: {
      container: 120,
      ring: 140,
      logo: 80,
    },
    large: {
      container: 160,
      ring: 180,
      logo: 100,
    }
  };

  const currentSize = sizes[size];

  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      minHeight={fullScreen ? '100vh' : '60vh'}
      sx={{
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          width: `${currentSize.ring}px`,
          height: `${currentSize.ring}px`,
          borderRadius: '50%',
          background: `conic-gradient(from 0deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${alpha(theme.palette.primary.main, 0.3)} 100%)`,
          animation: 'spin 2s linear infinite',
          '@keyframes spin': {
            '0%': {
              transform: 'rotate(0deg)',
            },
            '100%': {
              transform: 'rotate(360deg)',
            },
          },
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          width: `${currentSize.container}px`,
          height: `${currentSize.container}px`,
          borderRadius: '50%',
          background: theme.palette.background.paper,
          boxShadow: `0 0 20px ${alpha(theme.palette.primary.main, 0.1)}`,
        },
      }}
    >
      <Box
        component="img"
        src="/images/logo.png"
        alt="Loading..."
        sx={{
          width: `${currentSize.logo}px`,
          height: `${currentSize.logo}px`,
          position: 'relative',
          zIndex: 1,
          animation: 'pulse 2s ease-in-out infinite',
          '@keyframes pulse': {
            '0%': {
              transform: 'scale(1)',
              opacity: 0.8,
            },
            '50%': {
              transform: 'scale(1.1)',
              opacity: 1,
            },
            '100%': {
              transform: 'scale(1)',
              opacity: 0.8,
            },
          },
        }}
      />
    </Box>
  );
};

export default LoadingSpinner; 